import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../api';

export default function SetupPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await authApi.setup({ name, email, password });
      localStorage.setItem('token', res.data.token);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Fehler beim Setup');
    } finally { setLoading(false); }
  };

  return (
    <div style={{
      minHeight: '100vh', background: '#0f172a',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
    }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 56, marginBottom: 12 }}>🎉</div>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: '#f1f5f9' }}>Willkommen!</h1>
          <p style={{ color: '#64748b', marginTop: 8, fontSize: 14 }}>
            Erstelle deinen Account für den Vertragsmanager
          </p>
        </div>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <input type="text" value={name} onChange={e => setName(e.target.value)}
            placeholder="Dein Name (z.B. Peter)" style={inputStyle} />
          <input type="email" value={email} onChange={e => setEmail(e.target.value)}
            placeholder="E-Mail" required style={inputStyle} />
          <input type="password" value={password} onChange={e => setPassword(e.target.value)}
            placeholder="Passwort wählen" required minLength={6} style={inputStyle} />
          {error && <p style={{ color: '#f87171', fontSize: 14 }}>{error}</p>}
          <button type="submit" disabled={loading} style={btnStyle}>
            {loading ? 'Erstelle Account...' : 'Account erstellen'}
          </button>
        </form>
      </div>
    </div>
  );
}

const inputStyle = {
  background: '#1e293b', border: '1px solid #334155', color: '#f1f5f9',
  padding: '12px 16px', borderRadius: 8, fontSize: 16, outline: 'none',
};
const btnStyle = {
  background: '#818cf8', color: 'white', border: 'none',
  padding: '14px', borderRadius: 6, fontSize: 16, fontWeight: 600,
  cursor: 'pointer', marginTop: 8, minHeight: 44,
};
